<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding-top: 10px;">
    <h1 style="font-weight: bold; text-align: center; font-size: 16px;">Промени Парола</h1>
    <form [formGroup]="this.changePasswordsInfo">
        <div style="display: -webkit-box; width: 90%; margin: auto;">
            <input  style="width: 100%;" [type]="hide ? 'text': 'password'" [autoClose]="'outside'" [ngbPopover]="popContent" (input)="this.checkPassoword($event.target)" class="form-control" formControlName="newPassword" [placeholder]="this.pageDetails().newPassword" aria-label="Username" aria-describedby="basic-addon1">
            <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
        </div>
        <div style="display: -webkit-box; width: 90%; margin: auto;">
            <input  style="width: 100%;" [type]="hide ? 'text': 'password'" class="form-control" formControlName="confirmPassword" [placeholder]="this.pageDetails().confirmPassword" aria-label="Username" aria-describedby="basic-addon1">
            <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
        </div>
        <div style="position: fixed; bottom: 40px; text-align: center; width: 90%; margin: auto; left: 5%;">
            <button type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.change()"> {{ this.pageDetails().button }} </button>
        </div>
    </form>
</div>

<ng-template #popContent>
    <p class="popup">
        <span style="font-weight: bold; text-align: left;">Паролата трябва да съдържа</span>
        <br>
        <span [style]="this.isLengthCheckValid ? 'color: green;' : 'color: red;'">поне 8 символа</span>
        <br>
        <span [style]="this.isSmallLettersCheckValid ? 'color: green;' : 'color: red;'">малка буква</span>
        <br>
        <span [style]="this.isCapitalLettersCheckValid ? 'color: green;' : 'color: red;'">главна буква</span>
        <br>
        <span [style]="this.isDigitsCheckValid ? 'color: green;' : 'color: red;'">число</span>
        <br>
        <span [style]="this.isSymbolCheckValid ? 'color: green;' : 'color: red;'">символ</span>
    </p>
</ng-template>